:host {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  color: var(--main-titles-inputs-600);
  padding: 0 calc(1.5 * var(--spacer));
  height: calc(4 * var(--spacer));
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  outline: none;
  border: 1px solid transparent;
}

:host(:hover),
:host(:focus) {
  background-color: var(--chart-051-hover);
}
:host(:focus-visible) {
  border-color: var(--blue-layout-500-focus);
}

:host(.active) {
  background-color: var(--blue-layout-050-selected);
}

.hash {
  font-size: var(--body-size-medium);
  --font-family: var(--font-family-secondary);
}

gz-text {
  --font-family: var(--font-family-secondary);
}

gz-title {
  margin-left: 4px;
}

gz-text, gz-title {
  display: inline;
  max-height: calc(4 * var(--spacer));
}
